import React from 'react';
import { ImageModel, LinkModel } from '@/types';
import PodcastElement from './PodcastElement';
import EmbeddedMediaElement from './EmbeddedMediaElement';
import Box from '../animation/Box';
import { fadeIn } from '@/animations';
import { ResponsiveImageSizesType } from '../general/ResponsiveImage';
import LinksBlock from './LinksBlock';
import ImageElement from './ImageElement';
import VideoBlobStorageElement from './VideoBlobStorageElement';

export type NavigationInfoElementModel = {
  props: {
    title: string;
    text: string;
    link?: LinkModel;
  };
};

export type MediaElementModel = {
  moduleName:
    | 'StylusMediaItem'
    | 'PodcastElement'
    | 'EmbeddedMediaElement'
    | 'ImageElement'
    | 'VideoElement'
    | 'VideoBlobStorageElement'
    | 'LinksBlock';
  props: {
    coverImage?: ImageModel;
    videoEmbedCode?: string;
    summary?: string;
    title?: string;
    videoUrl?: string;
    codeId?: string;
    moduleName?: string;

    name?: string;
    media?: MediaElementModel;
    publishedDate?: string;
    duration?: string;
    noIndexing?: boolean;

    image?: ImageModel;
    podcast?: string;

    links?: NavigationInfoElementModel[];

    directory?: {
      name: string;
      date: string;
    };
  };
  imageElementProps: {
    widths: ResponsiveImageSizesType;
    heights: ResponsiveImageSizesType;
    className?: string;
  };
  alignment?: 'Left' | 'Right';
  backgroundColor?: string;
} & React.HTMLAttributes<HTMLDivElement>;

const MediaElement = ({
  moduleName,
  props,
  alignment,
  imageElementProps,
  backgroundColor,
  ...divProps
}: MediaElementModel) => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { podcast, codeId, videoEmbedCode, media, image } = props;

  let mediaItem: React.ReactNode = null;
  if (moduleName === 'StylusMediaItem' && media) {
    mediaItem = <MediaElement {...media} />;
  } else if (moduleName === 'PodcastElement' && podcast) {
    mediaItem = <PodcastElement podcast={podcast} />;
  } else if (moduleName === 'EmbeddedMediaElement') {
    mediaItem = <EmbeddedMediaElement {...props} videoEmbedCode={videoEmbedCode} className="print:hidden" />;
  } else if (moduleName === 'ImageElement') {
    mediaItem = <ImageElement image={image || props.coverImage} {...imageElementProps} />;
  } else if (moduleName === 'LinksBlock' && props.links) {
    mediaItem = <LinksBlock links={props.links} alignment={alignment} backgroundColor={backgroundColor} />;
  } else if (moduleName === 'VideoBlobStorageElement' && props.videoUrl) {
    mediaItem = (
      <VideoBlobStorageElement
        videoUrl={props.videoUrl}
        coverImage={props.coverImage}
        summary={props.summary}
        title={props.title}
        directory={props.directory}
      />
    );
  }

  return (
    <Box animation={fadeIn} {...divProps}>
      {mediaItem}
    </Box>
  );
};

export default MediaElement;
